var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAutomationQa(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6296_102805)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.0563 18.5892V15.0343H13.7617V11.8319H20.8474V3.96118H5.15259V11.8319H12.2383V15.0343H2.94375V18.5892H0V26.0001H7.41094V18.5892H4.46719V16.5577H12.2383V18.5892H9.29453V26.0001H16.7055V18.5892H13.7617V16.5577H21.5328V18.5892H18.5891V26.0001H26V18.5892H23.0563Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4922 0H20.8547V2.43766H10.4922V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.14844 0H8.9573V2.43766H5.14844V0Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6296_102805"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutomationQa);
export default __webpack_public_path__ + "static/media/automation_QA.d2f09f97d8aacadad2d73a7e1a74eb3a.svg";
export { ForwardRef as ReactComponent };